import React from "react";

import PlanCreate from "app/setup/modules/operator/features/managePlan/subFeatures/planCreate";

const OperatorPlanCreate = () => {
  return <PlanCreate />;
};

export default OperatorPlanCreate;
